import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
declare var cordova;
@Injectable({
    providedIn: 'root'
})
export class NativeAPIService {
    private deviceReady: Subject<any>;
    private backPress: Subject<any>;

    constructor() {
        //initiating observables 
        this.deviceReady = new Subject<any>();
        this.backPress = new Subject<any>();
        
        //initiating events 
        let regEv=(e,f)=>document.addEventListener(e,f,false);
        regEv("deviceready",(event) => this.deviceReady.next({ ready: true, event: event }));
        regEv("backbutton",(event) => {

            event.preventDefault();
            event.stopPropagation();
            this.backPress.next({ ready: true, event: event });
            return false;

        });
    }

    onDeviceReady() {
        return this.deviceReady.asObservable();
    }
    onBackPress(){
        return this.backPress.asObservable();
    }

}